// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Module-scoped styles for HelpTab */
.JxHgmp0S9P0OblS0FvVa {
  color: var(--help-container-content-color);
}
.vM69RqHVxxLxfH_hyWW7 {
  line-height: 1.5em;
  text-align: left;
  padding: 8px;
  width: 100%;
  max-width: 623px;
  margin: auto;
}
.vM69RqHVxxLxfH_hyWW7 img:first-of-type {
  display: inline-block;
  vertical-align: top;
  width: 24px;
  height: 24px;
}
.vM69RqHVxxLxfH_hyWW7 img:last-of-type {
  display: inline-block;
  vertical-align: middle;
  width: 22px;
  height: 22px;
}
.vM69RqHVxxLxfH_hyWW7 div {
  padding-bottom: 1em;
}
.vM69RqHVxxLxfH_hyWW7 h1 {
  font-size: 130%;
  padding-bottom: 0.3em;
}
.vM69RqHVxxLxfH_hyWW7 ul {
  line-height: 1.2;
}
/* Global styles for dynamically loaded HTML content */
/* fallow-ignore-next-line unused-export */
.lobby-noWrap-help {
  white-space: nowrap !important;
  display: inline-block !important;
}
`, "",{"version":3,"sources":["webpack://./src/features/settings/components/Help/HelpTab.module.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA,sDAAsD;AACtD,0CAA0C;AAC1C;EACE,8BAA8B;EAC9B,gCAAgC;AAClC","sourcesContent":["/* Module-scoped styles for HelpTab */\n.container {\n  color: var(--help-container-content-color);\n}\n.content {\n  line-height: 1.5em;\n  text-align: left;\n  padding: 8px;\n  width: 100%;\n  max-width: 623px;\n  margin: auto;\n}\n.content img:first-of-type {\n  display: inline-block;\n  vertical-align: top;\n  width: 24px;\n  height: 24px;\n}\n.content img:last-of-type {\n  display: inline-block;\n  vertical-align: middle;\n  width: 22px;\n  height: 22px;\n}\n.content div {\n  padding-bottom: 1em;\n}\n.content h1 {\n  font-size: 130%;\n  padding-bottom: 0.3em;\n}\n.content ul {\n  line-height: 1.2;\n}\n/* Global styles for dynamically loaded HTML content */\n/* fallow-ignore-next-line unused-export */\n:global(.lobby-noWrap-help) {\n  white-space: nowrap !important;\n  display: inline-block !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `JxHgmp0S9P0OblS0FvVa`,
	"content": `vM69RqHVxxLxfH_hyWW7`
};
export default ___CSS_LOADER_EXPORT___;
